import { Component } from "@angular/core";
import { NavController, NavParams, Platform } from "ionic-angular";
import { Camera } from "@ionic-native/camera";
import { AuthService } from "../../services/auth.service";
import { AppUtilities } from "../../app/app.utilities";

import { TranslateService } from "@ngx-translate/core";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "page-edit-user-profile",
  templateUrl: "edit-user-profile.html",
})
export class EditUserProfilePage {
  user: any;
  isWeb: boolean;
  userPhoto: any;
  nameChange: boolean;
  updateName: FormGroup;
  nombre: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private platform: Platform,
    private camera: Camera,
    fb: FormBuilder,
    private authService: AuthService,
    private utils: AppUtilities,
    private translateService: TranslateService
  ) {
    this.user = this.navParams.get("user");
    this.nameChange = this.navParams.get("nameChange");
    console.log("user ", this.user);

    //IS web this.isWeb true for web
    this.isWeb = true;

    this.nombre = this.translateService.instant("NOMBRE");

    this.updateName = fb.group({
      name: ["", Validators.compose([Validators.required])],
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad EditUserProfilePage");
  }

  readImageUrl(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.userPhoto = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  onChooseImageUrl() {
    let cameraOptions = {
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      destinationType: this.camera.DestinationType.DATA_URL,
      quality: 50,
      targetWidth: 1000,
      targetHeight: 1000,
      encodingType: this.camera.EncodingType.JPEG,
      correctOrientation: true,
    };

    this.camera.getPicture(cameraOptions).then(
      (imageData) => {
        this.userPhoto = "data:image/jpeg;base64," + imageData;
      },
      (error) => {
        console.debug("Unable to obtain picture: " + error, "app");
      }
    );
  }

  saveUserImage() {
    this.utils.loading();
    this.authService
      .uploadIamges(this.userPhoto, "userProfile", this.user.uid)
      .then((url) => {
        this.user.photoURL = url;
        this.authService.updateUserProfilePhoto(url);
        this.authService.writeUser(this.user).then(() => {
          this.utils.loadingDismiss();
          this.navCtrl.pop();
        });
      })
      .catch((err) => {
        this.utils.loadingDismiss();
      });
  }

  changeName() {
    this.utils.loading();
    let data = this.updateName.value;

    if (!data.name) {
      return;
    }

    var displayName = data.name;
    this.authService
      .updateUserName(this.user, displayName)
      .then(() => {
        this.user.displayName = displayName;
        this.utils.loadingDismiss();
        this.navCtrl.pop();
      })
      .catch((err) => {
        this.utils.loadingDismiss();
        console.log(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/edit-user-profile/edit-user-profile.ts